import { render } from "./DashboardWeekForm.vue?vue&type=template&id=408c2110"
import script from "./DashboardWeekForm.vue?vue&type=script&lang=js"
export * from "./DashboardWeekForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__